(function () {
  // Header sits transparent (dark gradient + white text) over the hero at the top of the
  // page, then switches to its normal solid band as soon as the visitor scrolls — matches
  // the original Claude Artifact demo. Toggles a class only (`.is-transparent` on the real
  // .bs-nav header); the actual style rules live in bs-hero-slider.css so bs-navigation.css
  // itself is never edited. Guarded by a data flag so re-running on shopify:section:load
  // doesn't stack duplicate scroll listeners.
  function initHeroHeaderTransparency() {
    var nav = document.querySelector('.bs-nav');
    if (!nav) return;
    var THRESHOLD = 300;
    var ticking = false;
    var getScrollTop = function () {
      var scroller = document.scrollingElement || document.documentElement || document.body;
      return window.pageYOffset || window.scrollY || scroller.scrollTop || 0;
    };
    var update = function () {
      ticking = false;
      nav.classList.toggle('is-transparent', getScrollTop() <= THRESHOLD);
    };
    if (nav.dataset.bsHeroBound !== '1') {
      nav.dataset.bsHeroBound = '1';
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      }, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('pageshow', update);
    }
    update();
    requestAnimationFrame(update);
    setTimeout(update, 80);
    setTimeout(update, 260);
  }

  function initHeroSlider(root) {
    initHeroHeaderTransparency();
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-bs-hero-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bs-hero-dot]'));
    var prevBtn = root.querySelector('[data-bs-hero-prev]');
    var nextBtn = root.querySelector('[data-bs-hero-next]');
    var track = root.querySelector('[data-bs-hero-slides]');
    var stage = root.querySelector('.bs-hero__stage');
    if (!slides.length) return;

    var AUTOPLAY_MS = 6000;
    var idx = 0;
    var timer;

    function isDesignMode() {
      return !!(
        window.Shopify &&
        (window.Shopify.designMode || window.Shopify.inspectMode)
      );
    }

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === idx); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === idx); });
    }

    function canNavigateSlides() {
      return isDesignMode() || !!(stage && stage.classList.contains('is-slide-navigation-enabled'));
    }

    function restart() {
      clearInterval(timer);
      if (isDesignMode()) return;
      if (slides.length > 1) {
        timer = setInterval(function () {
          if (canNavigateSlides()) show(idx + 1);
        }, AUTOPLAY_MS);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function () {
      if (!canNavigateSlides()) return;
      show(idx - 1);
      restart();
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (!canNavigateSlides()) return;
      show(idx + 1);
      restart();
    });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        if (!canNavigateSlides()) return;
        show(n);
        restart();
      });
    });

    if (track) {
      var touchStartX = 0;
      var suppressTrackClick = false;

      track.addEventListener('click', function (e) {
        if (suppressTrackClick) {
          suppressTrackClick = false;
          return;
        }
        if (!canNavigateSlides()) return;
        if (e.target.closest('a, button, input, select, textarea, [role="button"]')) return;
        show(idx + 1);
        restart();
      });

      track.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 40) {
          suppressTrackClick = true;
          if (canNavigateSlides()) {
            show(idx + (dx < 0 ? 1 : -1));
            restart();
          }
          setTimeout(function () { suppressTrackClick = false; }, 450);
        }
      }, { passive: true });
    }

    show(0);
    restart();

    if (isDesignMode()) {
      clearInterval(timer);
      document.addEventListener('shopify:block:select', function (event) {
        clearInterval(timer);
        var selectedSlide = event.target && event.target.matches && event.target.matches('[data-bs-hero-slide]')
          ? event.target
          : event.target && event.target.querySelector && event.target.querySelector('[data-bs-hero-slide]');
        if (!selectedSlide) return;
        var selectedIndex = slides.indexOf(selectedSlide);
        if (selectedIndex !== -1) show(selectedIndex);
      });
      document.addEventListener('shopify:section:select', function () {
        clearInterval(timer);
      });
    }

    // Scroll-driven door reveal: the black/yellow diagonal panels open with a slightly
    // accelerated motion while the sticky stage is pinned, revealing the active slide photo.
    var wrap = root.querySelector('.bs-hero-scroll-wrap');
    if (wrap && stage) {
      var START = { top: 42, bottom: 62 };
      var END = { top: 36, bottom: 56 };
      var easeOutExpo = function (x) {
        return x >= 1 ? 1 : 1 - Math.pow(2, -10 * x);
      };
      var easeInBack = function (x) {
        var c1 = 1.35;
        var c3 = c1 + 1;
        return c3 * x * x * x - c1 * x * x;
      };
      var doorEase = function (x) {
        var y = Math.max(0, Math.min(1, x));
        return Math.max(0, Math.min(1, easeOutExpo(Math.max(0, easeInBack(y) * 0.18 + y))));
      };
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var targetDoor = 0;
      var renderedDoor = 0;
      var doorVelocity = 0;
      var doorDirection = 0;
      var doorFrame = null;
      var ticking = false;
      var renderDoor = function (eased) {
        var top = START.top + (END.top - START.top) * eased;
        var bottom = START.bottom + (END.bottom - START.bottom) * eased;
        stage.style.setProperty('--bs-split-top', top + '%');
        stage.style.setProperty('--bs-split-bottom', bottom + '%');
        stage.style.setProperty('--bs-door-open', eased);
        stage.classList.toggle('is-slide-navigation-enabled', eased >= 0.78);
      };
      var settleDoor = function () {
        var distance = targetDoor - renderedDoor;
        if (Math.abs(distance) < 0.001) {
          renderedDoor = targetDoor;
          doorVelocity = 0;
          doorDirection = 0;
          renderDoor(renderedDoor);
          doorFrame = null;
          return;
        }
        var nextDirection = distance > 0 ? 1 : -1;
        if (nextDirection !== doorDirection) {
          doorVelocity = 0;
          doorDirection = nextDirection;
        }
        if (nextDirection > 0) {
          // Opening: a short visual hold, then accelerating travel like a powered door.
          doorVelocity = Math.min(0.045, doorVelocity + 0.00135);
          renderedDoor = Math.min(targetDoor, renderedDoor + doorVelocity);
        } else {
          // Closing: keep the existing fast approach with a soft final settle.
          renderedDoor += distance * 0.12;
        }
        renderDoor(renderedDoor);
        doorFrame = requestAnimationFrame(settleDoor);
      };
      var apply = function (immediate) {
        ticking = false;
        var wrapRect = wrap.getBoundingClientRect();
        var scrollable = wrap.offsetHeight - stage.offsetHeight;
        // Browser zoom can report a tiny negative top at scrollY 0 (for example -0.085px),
        // which otherwise leaves a visible photo seam between the closed door panels.
        var revealOffset = wrapRect.top > -1 ? 0 : -wrapRect.top;
        var progress = scrollable > 0 ? Math.min(1, Math.max(0, revealOffset / (scrollable * 0.62))) : 0;
        targetDoor = doorEase(progress);
        if (immediate || reducedMotion) {
          renderedDoor = targetDoor;
          renderDoor(renderedDoor);
          return;
        }
        if (!doorFrame) doorFrame = requestAnimationFrame(settleDoor);
      };
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(function () { apply(false); });
        }
      }, { passive: true });
      apply(true);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bs-hero').forEach(initHeroSlider);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var hero = e.target.querySelector ? e.target.querySelector('.bs-hero') : null;
    if (hero) initHeroSlider(hero);
  });
})();
